export default "__VITE_ASSET__CZNE2cmb__"